<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="https://instasaves.io/" title="InstaSave" rel="home">
          <img class="header-image is-logo-image" alt="InstaSave" src="../assets/logo.webp" title="InstaSave">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="https://instasaves.io/" rel="home">
          Instasaves
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
      </li> -->
      <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-34">
          <a href="https://instasaves.io/video-downloader/">Instagram Video Downloader</a>
      </li>
      <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://instasaves.io/instagram-apk-downlad/" class="download-btn">Download</a>
      </li>
      <li id="menu-item-35" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-35">
          <a href="https://instasaves.io/downloader-tips/">Tips</a>
      </li>
      <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-36">
          <a href="https://instasaves.io/blog/">Blog</a>
      </li>
      <!-- <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <a href="https://instasaves.io/blog/">Blogs</a>
      </li> -->
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
          <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
        </li> -->
        <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-34">
          <a href="https://instasaves.io/video-downloader/">Instagram Video Downloader</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="https://instasaves.io/instagram-apk-downlad/" class="download-btn">Download</a>
        </li>
        <li id="menu-item-35" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-35">
          <a href="https://instasaves.io/downloader-tips/">Tips</a>
        </li>
        <li id="menu-item-36" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-36">
          <a href="https://instasaves.io/blog/">Blog</a>
        </li>
        <!-- <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <router-link v-if="selectedLanguage === 'pt' || selectedLanguage === 'hi' || selectedLanguage === 'id'" :to="{ name: `${selectedLanguage}-blogs` }">{{ this.translation[selectedLanguage].blogs }}</router-link>
          <router-link v-else :to="{ name: `en-blogs` }">{{ this.translation[selectedLanguage].blogs }}</router-link>
          <a href="https://instasaves.io/blog/">Blogs</a>
        </li> -->
      </ul>
      <div class="language-selector">
        <select
          id="header-language-select"
          v-model="currentLanguageCode"
          @change="handleLanguageChange"
        >
          <option disabled value="">{{ languagePlaceholder }}</option>
          <option
            v-for="option in translationOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
      <div id="google-translate-container" aria-hidden="true">
        <div id="google_translate_element"></div>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
const LANGUAGE_STORAGE_KEY = 'instasaves-preferred-language';
import Search from './Search.vue';
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
      translationOptions: [
        { label: 'en', value: 'en' },
        { label: 'br', value: 'br' },
        { label: 'id', value: 'id' },
        { label: 'in', value: 'in' },
        { label: 'tr', value: 'tr' },
      ],
      languageRoutes: {
        en: '/',
        br: '/br/',
        id: '/id/',
        in: '/in/',
        tr: '/tr/',
      },
      currentLanguageCode: 'en',
      languagePlaceholder: 'choose language',
    }
  },
  mounted() {
    this.bootstrapBrowserTranslation();
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
    bootstrapBrowserTranslation() {
      if (this.$global && typeof this.$global.loadGoogleTranslate === 'function') {
        this.$global.loadGoogleTranslate().catch((error) => {
          console.warn('Failed to bootstrap browser translation.', error);
        });
      }
      if (typeof window === 'undefined' || !window.localStorage) {
        return;
      }
      try {
        const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (savedLanguage) {
          this.currentLanguageCode = savedLanguage;
          this.applyLanguage(savedLanguage);
        }
      } catch (error) {
        console.warn('Failed to read saved language from storage.', error);
      }
    },
    handleLanguageChange() {
      if (!this.currentLanguageCode) {
        return;
      }
      if (typeof window !== 'undefined' && window.localStorage) {
        try {
          window.localStorage.setItem(LANGUAGE_STORAGE_KEY, this.currentLanguageCode);
        } catch (error) {
          console.warn('Failed to persist selected language.', error);
        }
      }
      this.applyLanguage(this.currentLanguageCode);
      this.navigateToLanguagePage(this.currentLanguageCode);
    },
    applyLanguage(languageCode) {
      if (!languageCode) {
        return;
      }
      if (this.$global && typeof this.$global.setGoogleTranslateLanguage === 'function') {
        this.$global.setGoogleTranslateLanguage(languageCode);
      }
    },
    navigateToLanguagePage(languageCode) {
      const targetPath = this.languageRoutes[languageCode];
      if (!targetPath) {
        return;
      }
      if (this.$route?.path === targetPath) {
        return;
      }
      this.$router.push(targetPath).catch((error) => {
        if (error?.name !== 'NavigationDuplicated') {
          console.warn('Failed to navigate to language page.', error);
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;

  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

.language-selector {
  position: relative;

  select {
    min-width: 160px;
    padding: 8px 32px 8px 12px;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    background-color: #fff;
    color: #1f2937;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    appearance: none;
    background-image: url('~@/assets/down-black.svg');
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 12px;
  }

  select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.3);
  }
}

#google-translate-container {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }

  .language-selector {
    width: 100%;
    margin-top: 10px;

    select {
      width: 100%;
    }
  }
}
</style>
